import { Link, NavLink, Outlet } from 'react-router-dom'
import type { ReactNode } from 'react'
import type { Provenance } from '@fishstank/contracts'
import { ProvenanceFooter } from '../components/ProvenanceFooter'

interface Props {
  provenance?: Provenance | null
  children?: ReactNode
}

const navLinkClass = ({ isActive }: { isActive: boolean }) =>
  `px-2 py-1 rounded-md text-sm ${
    isActive
      ? 'bg-fishstank-surface text-fishstank-accent'
      : 'text-slate-300 hover:text-fishstank-accent'
  }`

export function Shell({ provenance = null, children }: Props) {
  return (
    <div className="min-h-screen bg-fishstank-ink text-slate-100 flex flex-col">
      <header className="border-b border-slate-800 bg-fishstank-ink/95 backdrop-blur sticky top-0 z-10">
        <div className="mx-auto max-w-screen-2xl px-4 py-3 flex items-center justify-between">
          <Link to="/" className="text-lg font-semibold tracking-tight">
            FishStank <span className="text-fishstank-accent">Admin</span>
          </Link>
          <nav className="flex items-center gap-1" data-testid="admin-nav">
            <NavLink to="/entities" className={navLinkClass}>
              Entities
            </NavLink>
            <NavLink to="/events" className={navLinkClass}>
              Events
            </NavLink>
            <NavLink to="/wiki" className={navLinkClass}>
              Wiki
            </NavLink>
            <NavLink to="/tts" className={navLinkClass}>
              TTS
            </NavLink>
            <NavLink to="/messages" className={navLinkClass}>
              Messages
            </NavLink>
            <NavLink to="/x-source" className={navLinkClass}>
              X-Source
            </NavLink>
            <NavLink to="/audit-history" className={navLinkClass}>
              Audit
            </NavLink>
            <NavLink to="/arcs" className={navLinkClass}>
              Arcs
            </NavLink>
            <span
              className="px-2 py-1 text-sm text-slate-600"
              title="Slice 2 CP5 — read only"
            >
              Mentions (soon)
            </span>
          </nav>
        </div>
      </header>
      <main className="flex-1 mx-auto max-w-screen-2xl w-full px-4 py-6">
        {children ?? <Outlet />}
      </main>
      <ProvenanceFooter provenance={provenance} />
    </div>
  )
}
